/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useRef, useState } from "react";
import "./login.styles.scss";

import { useHistory } from "react-router-dom";

import { connect } from "react-redux";
import { Dispatch } from "redux";
import { createStructuredSelector } from "reselect";

import {
  setUserLoggedInStatus,
  setUserData,
  setIdleModal,
  setAuthData,
} from "../../redux/user/user.actions";
import { selectUserData } from "../../redux/user/user.selectors";

import {
  Layout,
  Form,
  Input,
  Button,
  message,
  Modal,
  Spin,
  Typography,
} from "antd";
import jwtDecode from "jwt-decode";

import {
  loginService,
  forgotPwService,
  changePwService,
  changeResetService,
} from "../../services/login-services";

import {
  CopyrightOutlined,
  ExclamationCircleOutlined,
  RedoOutlined,
} from "@ant-design/icons";
import { ReactComponent as LogoITC } from "../../assets/ITCLogoLogin.svg";
import { ReactComponent as RightCornerSVG } from "../../assets/Vector 6.svg";
import { ReactComponent as LeftCornerSVG } from "../../assets/Vector 7.svg";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import { UserOutlined, LockOutlined, LoginOutlined } from "@ant-design/icons";
import { BarLoader } from "react-spinners";
import { User } from "../../models";
import triggerSleepClient from "../../services/timeout-services";
import { resetCommonReducer } from "../../redux/common/common.actions";
import QRCode from "react-qr-code";
// import { encrypt } from "../../utils/utils";
import { encryptLoginField } from "../../security/loginCrypto";

const { Footer } = Layout;
const { confirm } = Modal;

const LoginPage: React.FC = (props: any) => {
  const [loader, setLoader] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [forgotPwModal, setForgotPwModal] = useState(false);
  const [qrModal, setQrModal] = useState(false);
  /* const [mfaData, setMfa] = useState<any>({
    mfa_configured: 0,
    mfa_enabled: 0,
    qrCode: "",
  }); */
  const [rotating, setRotating] = useState(false);
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const [modal, contextHolder] = Modal.useModal();

  const { setUserLoggedIn, setUser, setAuthData } = props;
  const history = useHistory();
  useEffect(() => {
    let timer;
    if (qrModal === true) {
      timer = setTimeout(() => {
        // setMfa({});
        setLoader(false);
        setQrModal(false);
      }, 300000);
    } else {
      clearTimeout(timer);
    }
  }, [qrModal]);
  const onFinish = async (values: {
    username: string;
    password: string;
    captcha: string;
    otp?: number;
    reset?: boolean;
    force_login?: boolean;
  }) => {
    if (values.reset || validateCaptcha(values.captcha)) {
      try {
        console.log("window", window.crypto?.subtle);
        const eusername = await encryptLoginField(values.username);
        const epassword = await encryptLoginField(values.password);
        const dataToSend = {
          username: eusername,
          password: epassword,
          supplier: false,
          otp: values?.otp,
          // mfa_configured: values.totp && true,
          force_login: values.force_login,
        };

        setLoader(true);
        console.log("dataToSend", dataToSend);
        const loginResponse = await loginService(dataToSend);
        //TODO: autologout to be setup
        if (loginResponse.status === 200) {
          if (loginResponse.data.data.otp_required == true) {
            setQrModal(true);
            setTimeout(() => form.resetFields(["otp"]), 100);
            return false;
          }
          setAuthData(loginResponse.data.data);
          const idDetails: any = jwtDecode(loginResponse.data.data.id_token);
          setUser({
            ...idDetails,
            locationFeatureArray: idDetails.location_access.map(
              (item: any) => item.feature_code
            ),
            username: values.username,
            logout_timestamp:
              Math.round(new Date().getTime() / 1000) +
              loginResponse.data.data.refresh_token_expiry,
          });
          setUserLoggedIn(true);
          triggerSleepClient.onInit(history);
          history.replace("/home");
        } else {
          message.error("Login Failed.");
          setLoader(false);
        }
      } catch (error: any) {
        if (error.response) {
          if (error.response.data.hasOwnProperty("otp_required")) {
            // setMfa({
            //   ...mfaData,
            //   mfa_enabled: error.response.data.mfa_enabled,
            //   qrCode: error.response.data.totp_uri,
            // });
            setQrModal(true);
            message.warning(error.response.data.message);
            setTimeout(() => form.resetFields(["otp"]), 100);
          } else if (
            error.response.data?.data?.hasOwnProperty("force_login_required")
          ) {
            modal.confirm({
              title: "Login Alert",
              content: error.response.data?.message,
              closable: false,
              okButtonProps: {
                style: { border: 0 },
                type: "primary",
              },
              cancelButtonProps: {
                style: { border: 0 },
                danger: true,
                type: "primary",
              },
              keyboard: false,
              mask: true,
              centered: true,
              cancelText: "No",
              onCancel: () => {},
              okText: "Login Here",
              onOk: () =>
                onFinish({ ...form.getFieldsValue(), force_login: true }),
            });
          } else message.error(error.response.data.message);
        } else {
          console.log(error);
          message.error("Server Unavailable.");
        }
        setLoader(false);
      }
    } else {
      message.error("Please enter correct captcha value!");
      form.resetFields(["captcha"]);
    }
  };
  const onFinishSubmit = async (values) => {
    if (values && values.otp.length === 6) {
      const eotp = await encryptLoginField(values.otp);
      onFinish({
        ...form.getFieldsValue(),
        otp: eotp,
      });
    } else {
      message.error("Please enter valid OTP !");
    }
  };
  const onFinishReset = async (values: {
    old_password: string;
    new_password: string;
    confirm_password: string;
  }) => {
    try {
      setResetting(true);
      const eusername = await encryptLoginField(form.getFieldValue("username"));
      const epassword = await encryptLoginField(values.old_password);
      const enew_password = await encryptLoginField(values.new_password);
      const dataToSend = {
        user_name: eusername,
        old_password: epassword,
        new_password: enew_password,
      };

      const response = await changeResetService(dataToSend);

      if (response.status === 200) {
        setForgotPwModal(false);
        form.setFieldsValue({
          password: values.new_password,
        });
        onFinish({
          username: form.getFieldValue("username"),
          password: values.new_password,
          captcha: "",
          reset: true,
        });
      } else {
        message.error("Cannot reset password..!");
      }
    } catch (error: any) {
      if (error?.response?.data?.msg.includes("Incorrect old password"))
        message.error("Incorrect Reset Code.");
      else
        message.error(
          error?.response?.data?.msg ||
            "Something went wrong , Please try again later."
        );
    }
    setResetting(false);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  const onFinishFailedReset = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const forgotPwClicked = async () => {
    if (
      form.getFieldValue("username") !== null &&
      form.getFieldValue("username") !== "" &&
      form.getFieldValue("username") !== undefined
    ) {
      setSpinning(true);
      try {
        const euser_name = form.getFieldValue("username");
        const response = await forgotPwService({
          user_name: euser_name,
          supplier: false,
        });
        if (response.data.status) {
          setForgotPwModal(true);
          setSpinning(false);
        } else {
          message.warning("Error sending email...!");
          setSpinning(false);
        }
      } catch (error: any) {
        console.log(error);
        message.warning(
          error?.response?.data?.message ||
            "Something went wrong , Please try again later."
        );
        setSpinning(false);
      }
    } else {
      message.warning("Please enter username..!");
    }
  };

  function showPromiseConfirm() {
    confirm({
      title: "Reset Password ?",
      icon: <ExclamationCircleOutlined />,
      content:
        "A password reset code will be sent to your registered Email id, please use it to reset the password..",
      okText: "Reset",
      cancelText: "Cancel",
      onOk() {
        forgotPwClicked();
      },
      onCancel() {},
      okButtonProps: {
        style: {
          backgroundColor: "#123274",
          borderColor: "#123274",
        },
      },
    });
  }
  const logo = <LogoITC className="itc-logo" />;

  const ModalContent = () => {
    const [seconds, setSeconds] = useState(30);

    useEffect(() => {
      let timers: any;
      if (qrModal && seconds > 0) {
        timers = setInterval(() => {
          setSeconds(seconds - 1);
        }, 1000);
      } else {
        clearInterval(timers as NodeJS.Timeout);
      }
      return () => clearInterval(timers as NodeJS.Timeout);
    }, [qrModal, seconds]);

    return (
      <Modal
        open={qrModal}
        footer={false}
        maskClosable={false}
        closable={false}
        className="otp-modal"
      >
        <div className="reset-pw">
          <div className="header" style={{ textAlign: "center" }}>
            {/* {mfaData.mfa_enabled === 0
              ? "Set up multi-factor authentication"
              : " */}
            OTP Verification
          </div>
          <div className="login-form">
            <Form
              form={form3}
              // name="otp"
              initialValues={{ remember: false }}
              onFinish={onFinishSubmit}
              onFinishFailed={onFinishFailed}
            >
              {/* {mfaData.mfa_enabled === 0 ? (
                <>
                  <Form.Item>
                    <div className="left-container" style={{ width: "100%" }}>
                      <p style={{ marginBottom: "0px" }}>
                        <b>Step 1 -</b> To set up your multi-factor
                        authentication, scan QR code.
                      </p>
                    </div>
                  </Form.Item>
                  <Form.Item
                    style={{ textAlign: "center", marginBottom: "10px" }}
                  >
                    <QRCode
                      size={256}
                      style={{ height: "auto", maxWidth: "100%", width: "30%" }}
                      value={mfaData && mfaData.qrCode}
                      viewBox={`0 0 256 256`}
                    ></QRCode>
                  </Form.Item>
                  <Form.Item>
                    <div className="left-container" style={{ width: "100%" }}>
                      <p style={{ marginBottom: "0px" }}>
                        <b>Step 2 -</b> Once you have scanned the QR code,
                        complete the set up by entering the OTP listed in your
                        Authenticator App.
                      </p>
                    </div>
                  </Form.Item>
                </>
              ) : ( */}
              <Form.Item>
                <div className="left-container">
                  <p style={{ marginBottom: "0px" }}>
                    <b>Step 1 -</b> Enter the OTP sent to your registered email.
                  </p>
                </div>
              </Form.Item>
              {/* )} */}
              <Form.Item
                name="otp"
                rules={[
                  {
                    required: true,
                    message: "Please input OTP !",
                  },
                  {
                    validator: (_, value) => {
                      if (!value || /^\d{6}$/.test(value)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("OTP must be 6 digits"));
                    },
                  },
                ]}
                label="OTP"
                labelAlign="left"
                required
                style={{ marginBottom: "10px" }}
              >
                <Input.OTP
                  formatter={(str) => str.replace(/\D/g, "")}
                  length={6}
                  onInput={(value) => {
                    form3.setFieldValue("otp", value.join(""));
                  }}
                />
              </Form.Item>
              <Form.Item>
                Didn't receive an OTP code ?
                <Button
                  type="link"
                  size={"large"}
                  onClick={() => {
                    onFinish({
                      ...form.getFieldsValue(),
                    });
                    setSeconds(30);
                  }}
                  disabled={seconds > 0}
                >
                  Resend OTP
                </Button>
                <Typography.Text>
                  {seconds > 0 && `${seconds}s`}
                </Typography.Text>
              </Form.Item>
              <Form.Item>
                <div className="left-container" style={{ width: "100%" }}>
                  <p
                    className="password-guideline"
                    style={{ marginBottom: "0px" }}
                  >
                    <b>Step 2 - </b>
                    Click verify after entering OTP.
                  </p>
                </div>
              </Form.Item>
              <Form.Item style={{ marginBottom: "0px", marginTop: "0px" }}>
                <div className="reset-btn-container" style={{ width: "100%" }}>
                  <Button type="primary" size={"large"} block htmlType="submit">
                    Verify
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal>
    );
  };
  // const memoizedModalContent = useMemo(
  //   () => <ModalContent onClose={onFinishSubmit} />,
  //   [qrModal]
  // );
  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);
  useEffect(() => {
    const reloadCaptcha = document.getElementById("reload_href");
    document.addEventListener("click", function (event) {
      if (event.target === reloadCaptcha) {
        form.resetFields(["captcha"]);
      }
    });
  }, []);
  const reloadCaptcha = () => {
    if (rotating) return;
    form.resetFields(["captcha"]);
    setRotating(true);
    loadCaptchaEnginge(6);

    setTimeout(() => {
      setRotating(false);
    }, 400);
  };

  return (
    <Spin spinning={spinning}>
      <ModalContent />
      <BarLoader loading={loader} width={"100%"} color="#fdbc2c" />
      {contextHolder}
      <div className="login">
        <RightCornerSVG className="corner-svg-left" />
        <div className="login-container">
          {!forgotPwModal ? (
            <div className="right-container">
              <div className="logo-container">{logo}</div>
              <div className="header">Sign in</div>
              <div className="sub-header">
                Sign in and start managing your auctions
              </div>
              <Form
                form={form}
                // name="normal_login"
                // className="login-form"
                // initialValues={{ remember: true }}
                layout="vertical"
                size="large"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                  style={{ marginBottom: 0, fontWeight: 700 }}
                  name="username"
                  label="Username"
                  rules={[
                    {
                      required: true,
                      message: "Please input username !",
                    },
                  ]}
                >
                  <Input
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder={"User Name"}
                  />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: 0, fontWeight: 700 }}
                  name="password"
                  label="Password"
                  rules={[
                    {
                      required: true,
                      message: "Please input password !",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    // type="password"
                    placeholder={"Password"}
                  />
                </Form.Item>
                <Form.Item style={{ marginBottom: 5 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "0.5em",
                    }}
                  >
                    <Form.Item
                      label="Captcha"
                      style={{
                        marginBottom: 0,
                        fontWeight: 700,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          background: "#fff",
                          border: "0.5px solid #BFBFBF",
                        }}
                      >
                        <LoadCanvasTemplateNoReload />
                        <RedoOutlined
                          className={`reload-icon ${
                            rotating ? "rotating" : ""
                          }`}
                          onClick={reloadCaptcha}
                          title="Reload Captcha"
                        />
                      </div>
                    </Form.Item>
                    <Form.Item
                      name="captcha"
                      label="Enter Captcha"
                      style={{ marginBottom: 0, fontWeight: 700 }}
                      rules={[
                        {
                          required: true,
                          message: "Please input Captcha !",
                        },
                      ]}
                    >
                      <Input placeholder="Captcha" />
                    </Form.Item>
                  </div>
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    className="login-btn"
                    // icon={<LoginOutlined />}
                    size={"large"}
                    block
                    htmlType="submit"
                  >
                    Login
                  </Button>
                </Form.Item>
                <div style={{ textAlign: "center" }}>
                  <Button
                    type="link"
                    className="custom-link"
                    onClick={() => showPromiseConfirm()}
                  >
                    Forgot Password?
                  </Button>
                </div>
              </Form>
            </div>
          ) : (
            <div className="right-container">
              <div className="logo-container">{logo}</div>
              <div
                className="header"
                style={{
                  marginBlock: "40px 20px",
                  fontSize: 30,
                }}
              >
                Reset Password
              </div>
              <Form
                form={form2}
                name="reset_pw"
                initialValues={{ remember: false }}
                layout="vertical"
                size="large"
                onFinish={onFinishReset}
                onFinishFailed={onFinishFailedReset}
                style={{ width: "100%" }}
              >
                <Form.Item
                  name="old_password"
                  rules={[
                    {
                      required: true,
                      message: "Please input password !",
                    },
                  ]}
                  tooltip={
                    "A password reset code has been sent to the registered Email id."
                  }
                  label="Reset Code"
                  style={{
                    marginBottom: 0,
                    fontWeight: 700,
                  }}
                >
                  <Input.Password
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    // type="password"
                    placeholder={"Reset Code"}
                  />
                </Form.Item>
                <Form.Item
                  name="new_password"
                  dependencies={["old_password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please input password !",
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue("old_password") !== value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          "The new password should not be same as reset Code !"
                        );
                      },
                    }),
                  ]}
                  label="New Password"
                  style={{
                    marginBottom: 0,
                    fontWeight: 700,
                  }}
                >
                  <Input.Password
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    // type="password"
                    placeholder={"New Password"}
                  />
                </Form.Item>
                <Form.Item
                  name="confirm_password"
                  dependencies={["new_password"]}
                  hasFeedback
                  label="Confirm Password"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password !",
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue("new_password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          "Confirm password does not match with new password !"
                        );
                      },
                    }),
                  ]}
                  style={{
                    marginBottom: 10,
                    fontWeight: 700,
                  }}
                >
                  <Input.Password
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    // type="password"
                    placeholder={"Confirm Password"}
                  />
                </Form.Item>

                <Form.Item>
                  <div className="reset-btn-container">
                    <Button
                      type="primary"
                      size={"large"}
                      block
                      htmlType="submit"
                      loading={resetting}
                    >
                      Update Password
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </div>
          )}
        </div>
        <LeftCornerSVG className="corner-svg-right" />
      </div>
    </Spin>
  );
};

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setUserLoggedIn: (status: boolean) =>
      dispatch(setUserLoggedInStatus(status)),
    setAuthData: (authData: User) => dispatch(setAuthData(authData)),
    setUser: (userData: User) => dispatch(setUserData(userData)),
    setIdleModal: (show: boolean) => dispatch(setIdleModal(show)),
    resetReducer: () => dispatch(resetCommonReducer()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
